import { makeStyles } from '@material-ui/core/styles'
import { Box } from '@mui/material'
import { useSelector } from 'react-redux'

const AddonsCoverage = () => {
  const classes = useStyles()
  const motorDetails = useSelector((state) => state?.buyPolicyMotorReducer)
  const selectedQuote = motorDetails?.selectedQuote

  return (
    <Box className={classes.addOnContainer}>
      <Box className={classes.addOnHeading}>Addons coverage</Box>

      {selectedQuote?.addOns.length > 0 ? (
        <Box className={classes.descriptionSection}>
          {selectedQuote?.addOns?.map((item) => {
            return (
              <Box className={classes.addOnDescriptionItem} key={item?.id}>
                <Box>
                  <img src={item?.logoUrl} className={classes.addOnLogo} />
                </Box>
                <Box>
                  <Box className={classes.addOnTitle}>{item?.coverage}</Box>
                  <Box className={classes.addOnDescription}>
                    {item?.description}
                  </Box>
                </Box>
              </Box>
            )
          })}
        </Box>
      ) : (
        <Box className={classes.noAddOn}> No Addons Selected</Box>
      )}
    </Box>
  )
}

export default AddonsCoverage

const useStyles = makeStyles({
  addOnContainer: {
    border: '1px solid #BFD8D4',
    borderRadius: '10px',
    background: '#FFFFFF',
    marginTop: '40px',
  },
  addOnHeading: {
    fontFamily: 'Roboto',
    fontWeight: '500',
    fontSize: '18px',
    padding: '20px 30px',
    color: '#10A98F',
  },
  addOnTitle: {
    fontFamily: 'Roboto',
    fontWeight: '500',
    fontSize: '15px',
    lineHeight: '19.04px',
    color: '#323232',
    paddingBottom: '5px',
  },
  addOnDescription: {
    fontFamily: 'Roboto',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '15.23px',
    color: '#505050',
  },
  descriptionSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    padding: '10px',
  },
  addOnDescriptionItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 20,
    padding: '0px 30px',
  },
  addOnLogo: { width: '50px', height: '50px' },
  noAddOn: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: '500',
    color: '#10A98F',
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: '30px',
  },
})
